<template>
  <sfs-base-list-filter
    title="Filter Tax Rates"
    :table-name="tableName"
    :applied-filters="appliedFilters"
    :displayed-columns="displayedColumns"
    :available-columns="availableColumns"
    @filters-applied="onFiltersApplied"
    @filters-reset="onDefaultPresetApplied"
    @filter-cleared="onFilterCleared"
  >
    <template #quick-filters>
      <b-form-group
        label="Search fields for Data"
        label-for="quick-filter-text"
        label-sr-only
      >
        <b-input-group>
          <b-form-input
            id="quick-filter-text"
            v-model="filters.text"
            type="text"
            placeholder="Filter by Name, City, County or State"
            @keydown.enter.native="applyFilters"
          />
          <template #append>
            <b-button
              id="quick-filter-apply-button"
              @click="applyFilters"
              variant="primary"
            >
              <i class="fa fa-search" />
            </b-button>
          </template>
        </b-input-group>
      </b-form-group>
    </template>

    <template #advanced-filters>
      <b-row>
        <b-col
          cols="12"
          md="6"
          lg="4"
        >
          <b-form-group
            label="Name"
            label-for="advanced-filter-name"
            label-sr-only
          >
            <b-form-input
              id="advanced-filter-name"
              v-model="filters.name"
              type="text"
              placeholder="Name"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="6"
          lg="4"
        >
          <b-form-group
            label="City"
            label-for="advanced-filter-city"
            label-sr-only
          >
            <b-form-input
              id="advanced-filter-city"
              v-model="filters.city"
              type="text"
              placeholder="City"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="6"
          lg="4"
        >
          <b-form-group
            label="County"
            label-for="advanced-filter-county"
            label-sr-only
          >
            <b-form-input
              id="advanced-filter-county"
              v-model="filters.county"
              type="text"
              placeholder="County"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="6"
          lg="4"
        >
          <b-form-group
            label="State"
            label-for="advanced-filter-state"
            label-sr-only
          >
            <b-form-input
              id="advanced-filter-state"
              v-model="filters.state"
              type="text"
              placeholder="State"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="6"
          lg="4"
        >
          <b-form-group
            class="mb-3 mb-lg-0"
            label="Service Category"
            label-for="advanced-filter-service_category"
            label-sr-only
          >
            <service-category-select
              id="advanced-filter-service_category"
              placeholder="Select a Service Category"
              v-model="filters.service_category"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="6"
          lg="4"
        >
          <b-form-group
            class="mb-3 mb-lg-0"
            label="Charge Category"
            label-for="advanced-filter-charge_category"
            label-sr-only
          >
            <charge-category-select
              id="advanced-filter-charge_category"
              placeholder="Select a Charge Category"
              v-model="filters.charge_category"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="6"
          lg="4"
        >
          <b-form-group
            label="Active or Inactive"
            label-for="advanced-filter-active"
            label-sr-only
          >
            <b-form-radio-group
              id="advanced-filter-active"
              v-model="filters.active"
              :options="activeOptions"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </template>
  </sfs-base-list-filter>
</template>
<script>
import ChargeCategorySelect from '@/components/admin/workOrderCharges/CategorySelect.vue';
import ServiceCategorySelect from '@/components/admin/services/CategorySelect.vue';
import { TAX_RATE_TABLE_COLUMN_OPTIONS, TAX_RATE_TABLE_DEFAULT_COLUMNS, TAX_RATE_TABLE_NAME } from '@/constants/taxRates';
import listFilterMixin from '@/mixins/listFilterMixin';

export default {
  name: 'TaxRatesListFilter',
  mixins: [listFilterMixin],
  components: {
    ChargeCategorySelect,
    ServiceCategorySelect,
  },
  data() {
    return {
      availableColumns: TAX_RATE_TABLE_COLUMN_OPTIONS,
      tableName: TAX_RATE_TABLE_NAME,
    };
  },
  mounted() {
    this.applyFilters();
  },
  methods: {
    onDefaultPresetApplied() {
      this.filters = {};
      this.displayedColumns = TAX_RATE_TABLE_DEFAULT_COLUMNS;
      this.applyFilters();
    },
  },
};
</script>
